import React, { createContext, useCallback, useState, useContext } from 'react';
import KitchenService from 'services/KitchenService';
import { AlertMessagesContext } from 'react-alert-messages';

export const CommonContext = createContext();

export function CommonProvider({ children }) {
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const [kitchens, setKitchens] = useState(null);

  const fetchKitchens = useCallback(async () => {
    try {
      const response = await KitchenService.getKitchens();
      const data = response || [];
      return data;
    } catch (error) {
      postAlertMessage?.({
        text: error.message || 'Failed to fetch kitchens',
        type: 'failed',
        timeout: 5000,
      });
      return [];
    }
  }, [postAlertMessage]);

  const getKitchens = useCallback(async () => {
    if (kitchens) {
      return kitchens;
    }
    const _kitchens = await fetchKitchens();
    setKitchens(_kitchens);
    return _kitchens;
  }, [fetchKitchens, kitchens]);

  return (
    <CommonContext.Provider
      value={{
        kitchens,
        getKitchens,
        setKitchens,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
}

export default CommonProvider;
